import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ct-page-error',
  templateUrl: './page-error.component.html',
  styleUrls: ['./page-error.component.css']
})
export class PageErrorComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
